// Import model
import { DataviewPatternTypeOptionResponse } from '../models/DataviewPatternTypeOptionResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterPatternTypeOptionRequest } from '../models/FilterPatternTypeOptionRequest';
import { PatternTypeOption } from '../models/PatternTypeOption';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterPatternTypeOptionRequestSerializer } from './FilterPatternTypeOptionRequestSerializer';
import { PatternTypeOptionSerializer } from './PatternTypeOptionSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewPatternTypeOptionResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewPatternTypeOptionResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewPatternTypeOptionResponse instance
   */
  static deserialize(json: string): DataviewPatternTypeOptionResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewPatternTypeOptionResponse instance
   */
  static fromObject(obj: any): DataviewPatternTypeOptionResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewPatternTypeOptionResponse');
    }


    const instance: DataviewPatternTypeOptionResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        PatternTypeOptionSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterPatternTypeOptionRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewPatternTypeOptionResponse instances
   */
  static deserializeArray(json: string): DataviewPatternTypeOptionResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewPatternTypeOptionResponse instance to a JSON string
   */
  static serialize(instance: DataviewPatternTypeOptionResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewPatternTypeOptionResponse instance to a plain object
   */
  static toObject(instance: DataviewPatternTypeOptionResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        PatternTypeOptionSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterPatternTypeOptionRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewPatternTypeOptionResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewPatternTypeOptionResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
